<script lang="ts" setup>
import type { TripMonitorOrder, TripMonitorOrderStop } from "@/api/trips/dto/trip-monitor";
import { OrderStopType, OrderStopTypeMap } from "@/constants/order";
import { computed } from "vue";

const props = defineProps<{
  order: TripMonitorOrder;
}>();

function getOrderStopName(orderStop: TripMonitorOrderStop, index: number) {
  return `${OrderStopTypeMap[orderStop.type]}#${index + 1}`;
}

const nonEmptyOrderStopNotes = computed(() => {
  return props.order.orderStops.filter((orderStop) => orderStop.note);
});

const pickUpNotes = computed(() => {
  return nonEmptyOrderStopNotes.value.filter((orderStop) => orderStop.type === OrderStopType.pickup);
});

const deliveryNotes = computed(() => {
  return nonEmptyOrderStopNotes.value.filter((orderStop) => orderStop.type === OrderStopType.delivery);
});

const hasAnyNote = computed(() => {
  return nonEmptyOrderStopNotes.value.length || props.order.generalNote;
});
</script>

<template>
  <v-menu v-if="hasAnyNote" :close-on-content-click="false" :width="680">
    <template #activator="{ props: menuProps }">
      <v-btn
        class="text-primary ml-5 font-weight-600"
        data-qa="notes-button"
        prepend-icon="mdi-format-quote-close"
        size="small"
        v-bind="menuProps"
        variant="flat"
      >
        Notes
      </v-btn>
    </template>

    <v-card class="elevation-12 border">
      <div class="py-5 px-6">
        <span class="font-size-14 text-grey-darken-3">General note</span>

        <p v-if="order.generalNote" class="font-size-12 text-grey-darken-2 mt-2 white-space-pre-line">
          {{ order.generalNote }}
        </p>

        <!--        <div class="d-flex align-center">-->
        <!--          <span class="font-size-10 text-grey-darken-1 font-weight-500">Added by:</span>-->
        <!--          <span class="font-size-10 text-primary font-weight-500">Esther Howard</span>-->
        <!--        </div>-->

        <!--        <span class="text-grey font-size-10 mt-1">03/31/2024 06:58 (4 days ago)</span>-->

        <v-row class="mt-6">
          <v-col cols="6">
            <div
              v-for="(orderStop, index) of pickUpNotes"
              :key="orderStop.id"
              :class="{
                'mt-6': index !== 0,
              }"
            >
              <span>{{ getOrderStopName(orderStop, index) }} note</span>

              <p class="font-size-12 text-grey-darken-2 mt-2 white-space-pre-line" data-qa="pickup-notes-message">
                {{ orderStop.note }}
              </p>
            </div>
          </v-col>

          <v-col cols="6">
            <div
              v-for="(orderStop, index) of deliveryNotes"
              :key="orderStop.id"
              :class="{
                'mt-6': index !== 0,
              }"
            >
              <span>{{ getOrderStopName(orderStop, index) }} note</span>

              <p class="font-size-12 text-grey-darken-2 mt-2 white-space-pre-line" data-qa="delivery-notes-message">
                {{ orderStop.note }}
              </p>
            </div>
          </v-col>
        </v-row>
      </div>
    </v-card>
  </v-menu>
</template>

<style lang="scss" scoped></style>
